<footer class="v2f-footer">
    <div class="v2f-contenedor">
        <div class="v2f-columnas">

            <div class="v2f-col v2f-marca">
                <div class="v2f-marca-fila">
                    <span class="v2f-logo-circulo"><img src="./assets/logos/logo.png" alt="Liga Yucatán"></span>
                    <div>
                        <p class="v2f-marca-titulo">Liga Infantil y Juvenil</p>
                        <p class="v2f-marca-sub">de Béisbol Yucatán A.C.</p>
                    </div>
                </div>
                <p class="v2f-descripcion">Esta página de la Liga Yucatán es recreativa y con contenido educativo para todos los aficionados del rey de los deportes. No tenemos información sobre inscripciones ni temas de oficina.</p>
                <div class="v2f-redes">
                    <a href="https://www.facebook.com/LigaYucatanOficial" target="_blank" rel="noopener" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
                    <a href="https://api.whatsapp.com/message/OHPB4SNVXVK3B1?autoload=1&app_absent=0" target="_blank" rel="noopener" aria-label="WhatsApp"><i class="fab fa-whatsapp"></i></a>
                </div>
            </div>

            <div class="v2f-col">
                <h3 class="v2f-col-titulo">La Liga</h3>
                <ul class="v2f-lista">
                    <li><a [routerLink]="['/landing/inicio']">Inicio</a></li>
                    <li><a [routerLink]="['/landing/calendario']">Calendario</a></li>
                    <li><a [routerLink]="['/landing/estadisticas']">Estadísticas</a></li>
                    <li><a [routerLink]="['/landing/resultados-107']">Resultados 107</a></li>
                    <li><a [routerLink]="['/landing/reglas']">Reglamento</a></li>
                </ul>
            </div>

            <div class="v2f-col">
                <h3 class="v2f-col-titulo">Categorías</h3>
                <ul class="v2f-lista">
                    <li>Tee-ball 3-4</li>
                    <li>Iniciación 5-6</li>
                    <li>Kinder 7-8</li>
                    <li>Infantil menor 9-10</li>
                    <li>Infantil mayor 11-12</li>
                    <li>Juvenil menor 13-14</li>
                    <li>Juvenil mayor 15-17</li>
                    <li>División premier</li>
                </ul>
            </div>

            <div class="v2f-col v2f-buzon">
                <h3 class="v2f-col-titulo">Buzón de sugerencias</h3>
                <div class="v2f-buzon-grid">
                    <input class="v2f-input" type="text" placeholder="Tu nombre*" [(ngModel)]="buzon.nombre" style="text-transform: uppercase;">
                    <input class="v2f-input" type="email" placeholder="Tu correo*" [(ngModel)]="buzon.correo">
                    <input class="v2f-input" type="text" placeholder="Teléfono*" maxlength="10" [(ngModel)]="buzon.telefono">
                    <input class="v2f-input" type="text" placeholder="Asunto*" [(ngModel)]="buzon.asunto" style="text-transform: uppercase;">
                </div>
                <textarea class="v2f-input v2f-textarea" rows="3" placeholder="Escribe tu comentario aquí*" [(ngModel)]="buzon.comentario" style="text-transform: uppercase;"></textarea>
                <button type="button" class="v2f-boton" (click)="enviarBuzonCorreo()"><i class="far fa-paper-plane"></i> Enviar sugerencia</button>
            </div>

        </div>

        <div class="v2f-pie">
            <p class="v2f-copyright">© {{anio}} Liga Infantil y Juvenil de Béisbol Yucatán A.C. Todos los derechos reservados.</p>
            <p class="v2f-elaborado">Elaborado por <a class="v2f-serteza">SERTEZA</a></p>
        </div>
    </div>
</footer>
